import { Card } from "@mui/material";
import SpreadPriceForm1 from "./forms/SpreadPriceForm1";
import SpreadPriceForm2 from "./forms/SpreadPriceForm2";
import Grid2 from "@mui/material/Unstable_Grid2";
import Loading from "../../../components/loader/Loading";
import { BarChartOutlined } from "@mui/icons-material";
import useResponsive from "../../../components/hooks/useResponsive";
import { useGlobalMarketSpreadPriceContext } from "../../../context/global-market/GlobalMarketSpreadPriceContext";
import { sendData } from "../../../lib/dashboard/actions";
import { mutate } from "swr";
import AddToFavoritesButton from "../../../components/favorite/AddToFavoritesButton";
const GlobalMarketSpreadPriceForm = () => {
  const {
    inputValues1,
    inputValues2,
    isLoadingChart,
    handleShowChart,
    isFavoritesValidation,
  } = useGlobalMarketSpreadPriceContext();

  const { isMd, isLg, isXl } = useResponsive();

  const body = {
    industry_1_id: inputValues1.industry?.id,
    commodity_type_1_id: inputValues1.commodityType?.id,
    commodity_1_id: inputValues1.commodity?.id,
    transit_1_id: inputValues1.transitType?.id,
    industry_2_id: inputValues2.industry?.id,
    commodity_type_2_id: inputValues2.commodityType?.id,
    commodity_2_id: inputValues2.commodity?.id,
    transit_2_id: inputValues2.transitType?.id,
  };

  const handleAddToFavorite = async () => {
    const res = await sendData(body, "/favorite/global-favorite-ratio-chart");
    if (res.status === 200)
      await mutate("/favorite/global-favorite-ratio-chart");
  };

  const isDisabled = [
    inputValues1.industry?.id,
    inputValues1.commodityType?.id,
    inputValues2.industry?.id,
    inputValues2.commodityType?.id,
  ].every(Boolean);

  return (
    <Card>
      <Grid2 container spacing={"10px"}>
        <Grid2 xs={12}>
          <SpreadPriceForm1 />
        </Grid2>

        <Grid2 xs={12}>
          <SpreadPriceForm2 />
        </Grid2>
        <Grid2 xs={10} md={6}>
          <button
            style={{ height: "43px" }}
            onClick={() => handleShowChart(body)}
            className={`btn ${!isDisabled ? " btn-softblue" : "btn-blue"}`}
            disabled={!isDisabled || isLoadingChart}
          >
            {isLoadingChart ? (
              <Loading color={"#fff"} />
            ) : (
              <>
                {(isXl || !isLg) && "نمایش"}
                <BarChartOutlined />
              </>
            )}
          </button>
        </Grid2>
        <Grid2 xs={2} md={6}>
          <AddToFavoritesButton
            text={isMd && "افزودن به علاقمندی ها"}
            style={{ height: "44px" }}
            isDisabled={!isDisabled}
            onClick={handleAddToFavorite}
            isLoading={isFavoritesValidation}
          />
        </Grid2>
      </Grid2>
    </Card>
  );
};

export default GlobalMarketSpreadPriceForm;
